import { createContext, useContext, useEffect } from "react";
import { useLocalStorageState } from "../hooks";
import type { ChildrenProps } from "../types";

export type ColorMode = "light" | "dark";

/** Interface */
interface IColorModeContext {
	colorMode: ColorMode;
	setColorMode: (colorMode: ColorMode) => void;
	toggleColorMode: () => void;
}

export const ColorModeContext = createContext<IColorModeContext>({} as IColorModeContext);

export function useColorModeContext() {
	return useContext(ColorModeContext);
}

export function ColorModeProvider({ children }: ChildrenProps) {
	/** State */
	const [colorMode, setColorMode] = useLocalStorageState<ColorMode>("colorMode", "light");

	/** Effects */
	useEffect(() => {
		if (colorMode === "light") {
			document.body.classList.remove("dark");
		} else {
			document.body.classList.add("dark");
		}
	}, [colorMode]);

	/** Functions */
	function toggleColorMode() {
		setColorMode(colorMode === "light" ? "dark" : "light");
	}

	/** Render */
	return (
		<ColorModeContext.Provider value={{ colorMode, setColorMode, toggleColorMode }}>
			{children}
		</ColorModeContext.Provider>
	);
}
